module.exports = __webpack_public_path__ + "img/image5.53eca602.jpeg";